import React from "react";
import { LuMoveRight, LuSettings, LuFactory, LuWrench, LuShield } from "react-icons/lu";
import CapabilitiesImg from "../../assets/Capabilities.png";


export const Capabilities = () => {
    const capabilities = [
        {
            icon: <LuSettings />,
            title: "Pipeline systems and construction",
            description: "Reliable networks that move what matters",
        },
        {
            icon: <LuFactory />,
            title: "Fabrication and structural work",
            description: "Steel and metal shaped to exact specifications",
        },
        {
            icon: <LuShield />,
            title: "Insulation and refractory solutions",
            description: "Thermal protection engineered for performance",
        },
        {
            icon: <LuWrench />,
            title: "Industrial services and maintenance",
            description: "Ongoing support for systems that matter",
        },
    ];

    return (
        <section className="w-full py-16 px-4 md:px-10 bg-white">
            <div className="max-w-7xl mx-auto px-6">

                {/* Heading */}
                <div className="text-center space-y-4 mb-12">
                    <p className="text-sm text-gray-900">Capabilities</p>
                    <h2 className="text-3xl md:text-5xl font-bold text-gray-900">
                        What we build
                    </h2>
                    <p className="text-gray-700 font-medium mt-2">
                        Five core services that define our work
                    </p>
                </div>

                {/* Grid Layout */}
                <div className="grid md:grid-cols-2 gap-6">
                    {/* BIG CARD */}
                    <div className="border rounded-2xl flex flex-col justify-between">
                        <div className="px-10 py-6">
                            <p className="text-sm text-gray-500 mb-2">Service</p>
                            <h3 className="text-2xl md:text-3xl font-semibold text-gray-900">
                                Boiler erection and installation
                            </h3>
                            <p className="text-gray-500 mt-3">
                                Heavy equipment assembly with precision and care
                            </p>

                            <button className="mt-5 bg-primary-500 text-white px-5 py-2 rounded-md hover:bg-primary-600 transition">
                                Explore
                            </button>
                        </div>

                        {/* Image */}
                        <img
                            src={CapabilitiesImg}
                            alt="service"
                            className="rounded-b-xl object-cover h-52 w-full"
                        />
                    </div>

                    {/* SMALL CARDS */}
                    <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-6">
                        {capabilities.map((item, index) => (
                            <div
                                key={index}
                                className="border rounded-2xl p-5 hover:shadow-md transition group"
                            >
                                <div className="text-2xl mb-3">{item.icon}</div>

                                <h3 className="text-lg font-semibold text-gray-900">
                                    {item.title}
                                </h3>

                                <p className="text-gray-500 text-sm mt-2">
                                    {item.description}
                                </p>

                                <button className="group mt-4 text-orange-500 flex items-center gap-1 text-sm font-medium">
                                    Get Quote
                                    <LuMoveRight className="group-hover:translate-x-1 transition -rotate-45 group-hover:rotate-0" />
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};